import { render, staticRenderFns } from "./RecipientSetting.vue?vue&type=template&id=bdb3a884&scoped=true"
import script from "./RecipientSetting.vue?vue&type=script&lang=js"
export * from "./RecipientSetting.vue?vue&type=script&lang=js"
import style0 from "./RecipientSetting.vue?vue&type=style&index=0&id=bdb3a884&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bdb3a884",
  null
  
)

export default component.exports